/**
 * Cache em memoria das leituras do painel. Guarda a promessa, nao a resposta, o
 * que tambem deduplica requisicoes identicas ainda em voo - situacao comum agora
 * que as abas visitadas permanecem montadas. Falha nao entra no cache.
 */

const TTL_MS = 60000;

const CAPACIDADE = 60;

interface Entrada {
  expiraEm: number;
  promessa: Promise<any>;
}

const entradas = new Map<string, Entrada>();

const ordenar = (params?: object) => {
  if (!params) {
    return "";
  }
  const registro = params as { [chave: string]: unknown };
  return Object.keys(registro)
    .sort()
    .map((chave) => `${encodeURIComponent(chave)}=${encodeURIComponent(String(registro[chave]))}`)
    .join("&");
};

const descartarExpiradas = (agora: number) => {
  const vencidas: string[] = [];
  entradas.forEach((entrada, chave) => {
    if (entrada.expiraEm <= agora) {
      vencidas.push(chave);
    }
  });
  vencidas.forEach((chave) => entradas.delete(chave));
};

export const chaveCache = (url: string, params?: object) => `${url}?${ordenar(params)}`;

export const limparCacheGet = () => entradas.clear();

export const comCache = <T>(url: string, params: object | undefined, produtor: () => Promise<T>): Promise<T> => {
  const agora = Date.now();
  const chave = chaveCache(url, params);
  const atual = entradas.get(chave);
  if (atual && atual.expiraEm > agora) {
    return atual.promessa as Promise<T>;
  }
  descartarExpiradas(agora);
  // Map preserva a ordem de insercao, e a entrada so e (re)inserida no miss: a mais
  // antiga e sempre a mais proxima de vencer. Descartar so ela evita que o cache
  // inteiro seja jogado fora quando ha mais chaves ativas que capacidade.
  while (entradas.size >= CAPACIDADE) {
    const maisAntiga = entradas.keys().next();
    if (maisAntiga.done) {
      break;
    }
    entradas.delete(maisAntiga.value);
  }
  let entrada: Entrada | null = null;
  const promessa = produtor().catch((falha) => {
    // A entrada pode ter sido descartada por capacidade e substituida por outra
    // requisicao da mesma chave; apagar pela chave derrubaria a entrada nova.
    if (entrada && entradas.get(chave) === entrada) {
      entradas.delete(chave);
    }
    throw falha;
  });
  entrada = { expiraEm: agora + TTL_MS, promessa };
  entradas.set(chave, entrada);
  return promessa;
};
